const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaCombustivelMedia: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COMBUSTIVEL_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'COMBUSTIVEL_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
        case 'COMBUSTIVEL_MEDIA_SELECT_LISTADO':
            return { ...state, listaCombustivelMedia: action.payload.data };
        default:
            return state;
    }
}
